import React, { useEffect, useState } from 'react';
import { FaFileContract, FaEye, FaEdit } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { MdAddCircleOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Table from './Table';
import api from '~/services/api';
import {
  Container,
  FilterContainer,
  FilterItem,
  TableContainer,
  ActionsContainer,
  Action,
} from './styles';
import history from '~/services/history';
import { BarLoader } from '~/components';

function Inventory() {
  const isAdmin = useSelector(state => state.user.profile.isAdmin);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter] = useState();

  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [bodyTypeOptions, setBodyTypeOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);

  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [bodyType, setBodyType] = useState([]);
  const [color, setColor] = useState([]);
  const [year, setYear] = useState([]);
  const [uber, setUber] = useState(undefined);
  const openSimulationEditor = item => {
    history.push({
      pathname: '/vehicle/simulation',
      state: { item },
    });
  };
  const openVehicleEditor = item => {
    history.push({
      pathname: '/vehicle/edit',
      state: { item },
    });
  };
  useEffect(() => {
    async function loadOptions() {
      let params = {};
      if (make) {
        params = { ...params, make };
      }
      if (model) {
        params = { ...params, model };
      }
      if (bodyType) {
        params = { ...params, bodyType };
      }
      if (color) {
        params = { ...params, color };
      }
      if (year) {
        params = { ...params, year };
      }
      const result = await api.get('/inventory', { params });

      const {
        make: makeData,
        model: modelData,
        bodyType: bodyTypeData,
        color: colorData,
        year: yearData,
      } = result.data;

      setMakeOptions(
        makeData.map(item => {
          return { id: item, title: item };
        })
      );
      setModelOptions(
        modelData.map(item => {
          return { id: item, title: item };
        })
      );
      setBodyTypeOptions(
        bodyTypeData.map(item => {
          return { id: item, title: item };
        })
      );
      setColorOptions(
        colorData.map(item => {
          return { id: item, title: item };
        })
      );
      setYearOptions(
        yearData.map(item => {
          return { id: item, title: item };
        })
      );
    }
    loadOptions();
  }, [bodyType, color, filter, make, model, year]);

  useEffect(() => {
    async function loadInventory() {
      const response = await api.get('/vehicle', {
        params: {
          make,
          model,
          bodyType,
          color,
          year,
          uber,
        },
      });
      setData(
        response.data.map(item => {
          return {
            ...item,
            actions: (
              <ActionsContainer>
                <Action disabled onClick={() => {}}>
                  <FaEye />
                  <span>View</span>
                </Action>
                {isAdmin && (
                  <Action onClick={() => openVehicleEditor(item)}>
                    <FaEdit />
                    <span>Edit</span>
                  </Action>
                )}
                <Action onClick={() => openSimulationEditor(item)}>
                  <FaFileContract />
                  <span>Simulation</span>
                </Action>
              </ActionsContainer>
            ),
          };
        })
      );
      setLoading(false);
    }
    loadInventory();
  }, [bodyType, color, filter, isAdmin, make, model, uber, year]);
  const customStyles = {};
  return (
    <Container>
      {loading ? (
        <BarLoader />
      ) : (
        <>
          <FilterContainer>
            <h1>Filters</h1>
            <FilterItem
              name="make"
              label="Make"
              options={makeOptions}
              multiple
              styles={customStyles}
              defaultValue={
                make
                  ? make.map(item => {
                      return { id: item, title: item };
                    })
                  : undefined
              }
              onChange={makes => setMake(makes && makes.map(item => item.id))}
            />
            <FilterItem
              name="model"
              label="Model"
              options={modelOptions}
              multiple
              defaultValue={
                model
                  ? model.map(item => {
                      return { id: item, title: item };
                    })
                  : undefined
              }
              onChange={models =>
                setModel(models && models.map(item => item.id))
              }
              styles={customStyles}
            />
            <FilterItem
              name="bodyType"
              label="Body Type"
              options={bodyTypeOptions}
              multiple
              styles={customStyles}
              defaultValue={
                bodyType
                  ? bodyType.map(item => {
                      return { id: item, title: item };
                    })
                  : undefined
              }
              onChange={bodyTypes =>
                setBodyType(bodyTypes && bodyTypes.map(item => item.id))
              }
            />
            <FilterItem
              name="color"
              label="Color"
              options={colorOptions}
              defaultValue={
                color
                  ? color.map(item => {
                      return { id: item, title: item };
                    })
                  : undefined
              }
              multiple
              styles={customStyles}
              onChange={colors =>
                setColor(colors && colors.map(item => item.id))
              }
            />
            <FilterItem
              name="year"
              label="Year"
              options={yearOptions}
              defaultValue={
                year
                  ? year.map(item => {
                      return { id: item, title: item };
                    })
                  : undefined
              }
              multiple
              styles={customStyles}
              onChange={years => setYear(years && years.map(item => item.id))}
            />
            <FilterItem
              name="uber"
              label="Uber/Lyft/Delivery allowed?"
              options={[
                {
                  id: undefined,
                  title: 'Any',
                },
                {
                  id: true,
                  title: 'Yes',
                },
                {
                  id: false,
                  title: 'No',
                },
              ]}
              defaultValue={undefined}
              onChange={value => {
                if (value) {
                  setUber(value.id);
                }
              }}
            />
          </FilterContainer>
          <TableContainer>
            <header>
              <Link to="/vehicle/create">
                <MdAddCircleOutline color="#FFF" size={22} />
                New Vehicle
              </Link>
            </header>
            <Table data={data} />
          </TableContainer>
        </>
      )}
    </Container>
  );
}

export default Inventory;
